// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__i4x1d","upload":"Small_upload__18kQz","imageWrap":"Small_imageWrap__27D50","removeBtn":"Small_removeBtn__EoEON"};